const VALUES = ['Customer Service Enquiry', 'Head Office Enquiry'];

const checker = e => e.target.value === 'Libraries';

const hideShow = facilities => show => {
  facilities.style.display = show ? 'block' : 'none';
  facilities.setAttribute('aria-hidden', !show);
};

export default () => {
  const input = document.getElementById('contact_form_query_type');
  const facilities = document.getElementById('contact_facilities');
  if (!input || !facilities) return;

  if (VALUES.includes(input.value)) {
    const facilitiesShow = hideShow(facilities);
    const facilityTypes = document.getElementById('facility-types');
    facilitiesShow(false);

    facilityTypes.addEventListener('change', e => {
      facilitiesShow((e));
    });
  }
};
